import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../redux/store';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const GuestGate: React.FC<Props> = ({ children }) => {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default GuestGate;

